import { memo } from 'react';
import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';

import { useCanActAsBarRaiser } from '../v2-hooks/useCanActAsBarRaiser';
import { useIsViewRoute } from '../v2-hooks/useIsViewRoute';
import { usePublicationStatePanelViewModel } from './PublicationStatePanelViewModel';
import ActionPanelBase from './ActionPanelBase';
import { WorkflowProgressBar } from './WorkflowProgressBar';
import PublicationMetadata from './PublicationMetadata';
import { AuthorStatePanel } from './AuthorStatePanel';
import { ViewModeStatePanel } from './ViewModeStatePanel';
import BarRaiserStatePanel from './BarRaiserStatePanel';
import { PanelDivider } from './PanelDivider';

const PublicationStatePanel = memo(function PublicationStatePanel() {
  const vm = usePublicationStatePanelViewModel();
  const canActAsBarRaiser = useCanActAsBarRaiser();
  const isViewRoute = useIsViewRoute();

  const draftState = vm.workflow?.draftState;
  const isInPublisherReview = draftState === WorkflowState.PUBLISHER_REVIEW;

  const renderStagePanel = () => {
    // A bar raiser reviews on the view route, so their in-review panel (scan
    // findings + evaluation) must win over the read-only view-mode panel. A
    // publisher without the bar-raiser content role falls through to the
    // normal view.
    if (canActAsBarRaiser && isInPublisherReview) {
      return <BarRaiserStatePanel />;
    }
    if (isViewRoute) return <ViewModeStatePanel />;
    return <AuthorStatePanel />;
  };

  return (
    <ActionPanelBase title="Publication state">
      {vm.workflow && (
        <>
          <WorkflowProgressBar />
          <PanelDivider />
          <PublicationMetadata />
          <PanelDivider />
          {renderStagePanel()}
        </>
      )}
    </ActionPanelBase>
  );
});

export default PublicationStatePanel;
